import React from "react";
import RelatedBlock from "@/components/RelatedBlock";
import BaseCard from "@/components/cards/BaseCard";

/**
 * Renders a "More about Lutrom" related strip for About-cluster pages.
 * `excludeSlug` lets a page hide its own card ("" for /about root).
 */
const ABOUT_ITEMS = [
  {
    slug: "",
    to: "/about",
    title: "Our Story",
    blurb: "How and why Lutrom Engineering was founded in 2021.",
  },
  {
    slug: "team",
    to: "/about/team",
    title: "The Team",
    blurb: "The engineering disciplines behind every job — under one roof.",
  },
  {
    slug: "quality-and-compliance",
    to: "/about/quality-and-compliance",
    title: "Quality & Compliance",
    blurb: "Externally audited ISO 9001, 14001 and 45001 management systems.",
  },
  {
    slug: "accreditations",
    to: "/about/accreditations",
    title: "Accreditations",
    blurb: "ISO, SafeContractor, IPAF and City & Guilds — proof of competence.",
  },
  {
    slug: "careers",
    to: "/about/careers",
    title: "Careers",
    blurb: "Life at Lutrom and how to get on our radar.",
  },
];

const AboutRelated = ({ excludeSlug }) => {
  const items = ABOUT_ITEMS.filter((i) => i.slug !== excludeSlug).map((i) => (
    <BaseCard
      key={i.to}
      to={i.to}
      eyebrow="About Lutrom"
      title={i.title}
      blurb={i.blurb}
      testid={`about-related-${i.slug || "root"}`}
    />
  ));

  return (
    <RelatedBlock
      title="More about Lutrom"
      groups={[{ eyebrow: "About", items }]}
    />
  );
};

export default AboutRelated;
